
import { ControlElement } from '@jsonforms/core';
import { rendererProps, RendererProps, useJsonFormsEnumControl } from '@jsonforms/vue';
import { defineComponent, computed } from 'vue';
import { useClearOnRefresh, useApiCallResource, EnumOption, useAutoSetOnChange } from '../../util';

const controlRenderer = defineComponent({
  name: 'enum-control-renderer',
  components: {},
  props: {
    ...rendererProps<ControlElement>(),
  },
  setup(props: RendererProps<ControlElement>) {
    const input = useJsonFormsEnumControl(props);

    useClearOnRefresh(input.control, input.handleChange);

    const staticOptions = computed<EnumOption[]>(() =>
      (input.control.value?.options ?? []).map((item: any) => {
        const isDisabled = input.control.value.uischema?.options?.disabledOptions?.includes(item.value);
        return isDisabled ? { ...item, disable: true } : item;
      }),
    );

    useAutoSetOnChange(input.control, input.handleChange);
    const { filteredOptions, isApiLoading, filterFn } = useApiCallResource(input.control, staticOptions);

    return { ...input, filteredOptions, filterFn, isApiLoading };
  },
  data() {
    return {
      disable: false,
      search: '',
      isTouched: false,
    };
  },
  mounted() {
    if (
      this.control?.data?.length &&
      !this.control?.uischema?.options?.editable &&
      !this.control?.config?.editableHydratedFields
    ) {
      this.disable = true;
    }
    if (!this.control.data && this.control.uischema.options?.default) {
      this.control.data = this.control.uischema.options.default;
      this.onChange(this.control.data);
    }
  },
  methods: {
    onBlur() {
      this.isTouched = true;
    },
    onFocus() {
      // Optionally mark as touched on focus
    },
    onChange(value: any) {
      this.isTouched = true;
      this.handleChange(this.control.path, value);
    },
  },
});

export default controlRenderer;
